const Throttle = require('./lib/throttle')
const ThrottleGroup = require('./lib/throttle-group')

module.exports = {
  Throttle,
  ThrottleGroup
}
